import { QuickAdd } from 'components/product-ui/quick-add/quick-add';
import { useTranslation } from 'next-i18next';
import { ProductUIAppWindow } from '../product-ui-app-window/product-ui-app-window';
import { ProductUIButton } from '../product-ui-button/product-ui-button';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { TemplateSidebarStandard } from '../product-ui-sidebar/product-ui-sidebar-templates';
import { TemplateTodayView } from '../product-ui-view/product-ui-view-templates';
function TaskDescriptionsScene() {
  const {
    t
  } = useTranslation('productui');
  return <ProductUISceneContainer backgroundVariant="wave-one" data-sentry-element="ProductUISceneContainer" data-sentry-component="TaskDescriptionsScene" data-sentry-source-file="task-descriptions.tsx">
            <ProductUISceneLayer position="modalOpenLeft" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="task-descriptions.tsx">
                <ProductUIAppWindow sidebar={<TemplateSidebarStandard />} view={<TemplateTodayView />} inlineSize={808} blockSize="calc(100% + 7px)" showOverlay data-sentry-element="ProductUIAppWindow" data-sentry-source-file="task-descriptions.tsx" />
            </ProductUISceneLayer>
            <ProductUISceneLayer position="center" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="task-descriptions.tsx">
                <QuickAdd taskSection={<QuickAdd.TaskText>
                            <QuickAdd.Intent>
                                {t('sequence.taskDescriptions.fellowship')}
                            </QuickAdd.Intent>
                        </QuickAdd.TaskText>} descriptionSection={<TaskDescription />} footerSection={<QuickAdd.FooterContainer>
                            <QuickAdd.FooterProjectButton />
                            <QuickAdd.FooterSpacer />
                            <ProductUIButton className="addTaskButton" variant="primary" data-productui="cta">
                                {t('quickAdd.addTask')}
                            </ProductUIButton>
                        </QuickAdd.FooterContainer>} data-sentry-element="QuickAdd" data-sentry-source-file="task-descriptions.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}
function TaskDescription() {
  const {
    t
  } = useTranslation('productui');
  return <QuickAdd.DescriptionText data-sentry-element="unknown" data-sentry-component="TaskDescription" data-sentry-source-file="task-descriptions.tsx">
            {t('sequence.taskDescriptions.deadline')}
            <ul style={{
      marginTop: 'var(--space-32)'
    }}>
                <li>
                    🔗{' '}
                    <span style={{
          textDecoration: 'underline'
        }}>
                        {t('sequence.taskDescriptions.application')}
                    </span>
                </li>
                <li>
                    ✏️{' '}
                    <span style={{
          textDecoration: 'underline'
        }}>
                        {t('sequence.taskDescriptions.draft')}
                    </span>
                </li>
                <li>
                    💌{' '}
                    <span style={{
          textDecoration: 'underline'
        }}>
                        {t('sequence.taskDescriptions.letter')}
                    </span>
                </li>
            </ul>
        </QuickAdd.DescriptionText>;
}
export { TaskDescriptionsScene };